import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../shared/shared.module';

import { ReportRoutingModule } from './report-routing.module';

import { ReportDetailsComponent } from './report-details/report-details.component';
import { ReportListComponent } from './report-list/report-list.component';
import { ReportRequirementListComponent } from './report-requirement-list/report-requirement-list.component';
import { OrganizationListComponent } from './organization-list/organization-list.component';
import { OrganizationDetailsComponent } from './organization-details/organization-details.component';
import { ReportAspectGroupListComponent } from './report-aspect-group-list/report-aspect-group-list.component';
import { ReportAspectTextListComponent } from './report-aspect-text-list/report-aspect-text-list.component';
import { ReportAspectGroupDetailsComponent } from './report-aspect-group-details/report-aspect-group-details.component';
import { BusinessListComponent } from './business-list/business-list.component';
import { BusinessDetailsComponent } from './business-details/business-details.component';
import { ReportProposalListComponent } from './report-proposal-list/report-proposal-list.component';
import { ReportSummaryComponent } from './report-summary/report-summary.component';
import { FinancierListComponent } from './financier-list/financier-list.component';
import { FinancierDetailsComponent } from './financier-details/financier-details.component';
import { RequirementListComponent } from './requirement-list/requirement-list.component';
import { RequirementDetailsComponent } from './requirement-details/requirement-details.component';
import { AspectGroupListComponent } from './aspect-group-list/aspect-group-list.component';
import { AspectGroupDetailsComponent } from './aspect-group-details/aspect-group-details.component';
import { AspectListComponent } from './aspect-list/aspect-list.component';
import { AspectDetailsComponent } from './aspect-details/aspect-details.component';
import { AspectTextListComponent } from './aspect-text-list/aspect-text-list.component';
import { BusinessCategoryListComponent } from './business-category-list/business-category-list.component';
import { BusinessCategoryDetailsComponent } from './business-category-details/business-category-details.component';
import { AspectTextDetailsComponent } from './aspect-text-details/aspect-text-details.component';
import { MethodVersionListComponent } from './method-version-list/method-version-list.component';
import { MethodVersionDetailsComponent } from './method-version-details/method-version-details.component';
import { StandardGroupListComponent } from './standard-group-list/standard-group-list.component';
import { StandardGroupDetailsComponent } from './standard-group-details/standard-group-details.component';
import { StandardListComponent } from './standard-list/standard-list.component';
import { StandardDetailsComponent } from './standard-details/standard-details.component';
import { ReportStandardGroupListComponent } from './report-standard-group-list/report-standard-group-list.component';
import { ReportStandardListComponent } from './report-standard-list/report-standard-list.component';
import { ReportStandardDetailsComponent } from './report-standard-details/report-standard-details.component';
import { ReportSummary2Component } from './report-summary2/report-summary2.component';
import { ReportSummary6Component } from './report-summary6/report-summary6.component';
import { ReportSummary19Component } from './report-summary19/report-summary19.component';
import { ReportStandardGroupDetailsComponent } from './report-standard-group-details/report-standard-group-details.component';
import { BaseChartDirective, provideCharts, withDefaultRegisterables } from 'ng2-charts';

@NgModule({
    imports: [
        SharedModule,
        CommonModule,
        ReportRoutingModule,
        BaseChartDirective
  ],
     providers: [
        provideCharts(withDefaultRegisterables())
    ],
    declarations: [
        ReportDetailsComponent,
        ReportListComponent,
        ReportRequirementListComponent,
        FinancierListComponent,
        FinancierDetailsComponent,
        OrganizationListComponent,
        OrganizationDetailsComponent,
        ReportAspectGroupListComponent,
        ReportAspectTextListComponent,
        ReportAspectGroupDetailsComponent,
        BusinessListComponent,
        BusinessDetailsComponent,
        ReportProposalListComponent,
        ReportSummaryComponent,
        RequirementListComponent,
        RequirementDetailsComponent,
        AspectGroupListComponent,
        AspectGroupDetailsComponent,
        AspectListComponent,
        AspectDetailsComponent,
        AspectTextListComponent,
        BusinessCategoryListComponent,
        BusinessCategoryDetailsComponent,
        AspectTextDetailsComponent,
        MethodVersionListComponent,
        MethodVersionDetailsComponent,
        StandardGroupListComponent,
        StandardGroupDetailsComponent,
        StandardListComponent,
        StandardDetailsComponent,
        ReportStandardGroupListComponent,
        ReportStandardListComponent,
        ReportStandardDetailsComponent,
        ReportSummary2Component,
        ReportSummary6Component,
        ReportSummary19Component,
        ReportStandardGroupDetailsComponent],
    exports: [
        ReportListComponent,
        BusinessListComponent]
})
export class ReportModule { }
